import src from "IMAGE";
export default { src, width: 605, height: 484, blurWidth: 0, blurHeight: 0};
